import { useState } from "react";
import { MailCheck } from "lucide-react";
import { authApi, errorMessage } from "@/lib/api";
import { AuthCard, FormError, SubmitButton, authField } from "@/components/admin/AuthCard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Forgot password" subtitle="Enter the owner email. We'll send a reset link." onSubmit={submit} testId="forgot-password-page">
      {sent ? (
        <p className="mt-6 flex gap-3 rounded-xl bg-[#E6F2EA] p-4 text-sm text-[#1B4332]" data-testid="forgot-password-sent">
          <MailCheck className="h-5 w-5 shrink-0" /> If this email belongs to the owner, a reset link is on its way. Check your inbox and spam folder. The link expires in 30 minutes.
        </p>
      ) : (
        <>
          <label className="mt-6 block text-sm font-medium">Email
            <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={authField} data-testid="forgot-password-email-input" />
          </label>
          <FormError error={error} testId="forgot-password-error" />
          <SubmitButton busy={busy} label="Send reset link" busyLabel="Sending…" testId="forgot-password-submit" />
        </>
      )}
    </AuthCard>
  );
}
